import React from 'react';
import {
	Alerts,
	Button,
	Col,
	Row,
	Slider,
	Toast as notificationPopUp,
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from '../ApiKeys.module.scss';
import CopyImg from '../../../../../assets/CopySVG.svg';

export type MapStatePropsType = {
	params: any;
};

export type DispatchPropsType = {
	onClose: () => void;
};

const APIKeyCreateSuccess: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onClose,
	params
}) => {
	const { t } = useTranslation();

	const generateSuccessContent = () => {
		return (
			<>
				<Alerts
					content={t('apiKeyAlert')}
					containerClassName={Styles.alertStyle}
					type="info"
				/>
				<div className={Styles.apiDetails}>{t('apiDetails')}</div>
				<Row>
					<Col size={4}>
						<div className={Styles.apiKeyTableCol1}>
							{t('apiDomain')}
						</div>
						<div className={Styles.apiKeyTableCol1}>
							{t('apiSid')}
						</div>
						<div className={Styles.apiKeyTableCol1}>
							{t('apiKey')}
						</div>
					</Col>
					<Col gutter size={8}>
						<div className={Styles.apiKeyTableCol2}>
							{params?.host}
						</div>
						<div className={Styles.apiKeyTableCol2Margin}>
							{params?.sid}
						</div>
						<Row>
							<Col size={10}>
								<p className={Styles.apiKeyP}>
									{params?.api_key_full}
								</p>
							</Col>
							<Col size={2}>
								<img
									src={CopyImg}
									className={Styles.copyImgEdit}
									onClick={() => {
										navigator.clipboard.writeText(
											params?.api_key_full
										);
										notificationPopUp(
											t('mainCopiedToClipboard'),
											'success',
											() => null
										);
									}}
									alt="copy"
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			</>
		);
	};
	const getFooterForSuccess = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={handleDownload}>
					{t('mainDownload')}
				</Button>
			</div>
		);
	};
	// const handleDownload = async () => {
	// 	await onDownload({ id: params?.id });
	// 	onClose();
	// };

	const handleDownload = () => {
		onClose();
	};

	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={getFooterForSuccess()}
			title={t('createAPIKeySuccess')}
			dialog={true}
		>
			<div className={Styles.container}>{generateSuccessContent()}</div>
		</Slider>
	);
};

export default APIKeyCreateSuccess;
